export default {
    /**
    * 金额小写转大写
    */
    numberRevert (n) {     
        // function DX(n) {
        let absn = Math.abs(n);
        if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(absn)) {
            return "数据非法";
        }
        let unit = "千百拾亿千百拾万千百拾元角分";
        let str = "";
        absn += "00";
        let p = absn.indexOf('.');
        if (p >= 0) {
            absn = absn.substring(0, p) + absn.substr(p + 1, 2);
        }
        unit = unit.substr(unit.length - absn.length);
        for (var i = 0; i < absn.length; i++) {
            str += '零壹贰叁肆伍陆柒捌玖'.charAt(absn.charAt(i)) + unit.charAt(i);
        }
        return (parseInt(n) < 0 ? "负" : "") + str.replace(/零(千|百|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整").replace(/^分$/g,"零元整");
        // }
    }
}